import Logger from '@/config/Logger';
import { SocketRequest } from '@/config/socket';
import { SOCKET_EVENT_NAMES } from '@/constants/socket.events';
import { notify } from '@/helpers';
import { activityLogStore } from '@/state/ActivityLogStore';
import { SocketResponse } from '@/types/socketResponse.type';

export const useActivityLog = () => {
  const getActivityLogs = async (
    contactId?: string,
    debouncedSearchValue?: string,
    showLoader = true,
  ) => {
    try {
      if (showLoader) {
        activityLogStore.setFetchingLogs(true);
      }

      const response: SocketResponse<any> = await SocketRequest(
        SOCKET_EVENT_NAMES.GET_ACTIVITY_LOGS,
        {
          data: {
            contactId,
            search: debouncedSearchValue,
          },
        },
      );

      if (response?.error) {
        notify('error', response?.error as string);
        activityLogStore.setError(response?.error as string);
      } else if (response?.data) {
        activityLogStore.setActivityLogs(response?.data);
      }
    } catch (error) {
      Logger.error("Error in 'get activity logs':", error);
      notify('error', 'Error getting activity logs');
    } finally {
      if (showLoader) {
        activityLogStore.setFetchingLogs(false);
      }
    }
  };

  const getAllActivityLogs = async () => {
    try {
      activityLogStore.setFetchingLogs(true);

      const response: SocketResponse<any> = await SocketRequest(
        SOCKET_EVENT_NAMES.GET_ACTIVITY_LOGS,
        {
          data: {},
        },
      );

      if (response?.error) {
        notify('error', response?.error as string);
        activityLogStore.setError(response?.error as string);
      } else if (response?.data) {
        activityLogStore.setActivityLogs(response?.data);
      }
    } catch (error) {
      Logger.error("Error in 'get activity logs':", error);
      notify('error', 'Error getting activity logs');
    } finally {
      activityLogStore.setFetchingLogs(false);
    }
  };

  return {
    getActivityLogs,
    getAllActivityLogs,
  };
};
